import type { Resolver } from 'cpool-schemas';
import { z } from 'zod';

type Arguments = {
    aggregateId: string;
};

export const schemaUserResolver_GetRegistrationStep = z.number();

export type SchemaUserResolver_GetRegistrationStep = z.infer<typeof schemaUserResolver_GetRegistrationStep>;

export type UserResolver_GetRegistrationStep = Resolver<Arguments, SchemaUserResolver_GetRegistrationStep>;
